import { createContext, useContext } from "react";
import { useParams } from "react-router-dom";

import { ExtendedActionPlanDetail, useActionPlan } from "../../api/v2/getActionPlan";

const ActionPlanResultsContext = createContext<{
  actionPlan: ExtendedActionPlanDetail | undefined;
  actionPlanId: string;
  isActionPlanLoading: boolean;
  isActionPlanFetching: boolean;
} | null>(null);

export const ActionPlanResultsProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { uuid } = useParams<{ uuid: string }>();
  const {
    data: actionPlan,
    isLoading: isActionPlanLoading,
    isFetching: isActionPlanFetching,
  } = useActionPlan({
    actionPlanId: uuid,
  });

  return (
    <ActionPlanResultsContext.Provider
      value={{
        actionPlan,
        actionPlanId: uuid,
        isActionPlanLoading,
        isActionPlanFetching,
      }}
    >
      {children}
    </ActionPlanResultsContext.Provider>
  );
};

export const useActionPlanResultsContext = () => {
  const context = useContext(ActionPlanResultsContext);
  if (!context) {
    throw new Error("useActionPlanResultsContext must be used within an ActionPlanResultsProvider");
  }
  return context;
};
